<template>

  <div class="etx-container Container" :class="paragraphClassList" v-if="teasers && teasers.length > 0">

    <div class="etx-center Center">

      <!-- <LoaderSwiper /> -->
      <div class="swiper Swiper SwiperCards" :class="entranceClassList" :data-swiper-id="id">

        <div class="swiper-wrapper Swiper__wrapper">

          <div v-for="teaser in teasers" class="swiper-slide Swiper__wrapper__slide">

            <div class="etx-card Card has-shadow has-hover" :class="entranceClassList">

              <a class="etx-card__link Card__link" :href="teaser?.url?.path" :title="teaser?.heading"></a>

              <div class="etx-card__item Card__item ph-0 pv-0">

                <div class="etx-media Media">
                  <MediaImage :media="teaser?.image" imageStyle="image_3_2" />
                </div>

              </div>

              <div class="etx-card__item Card__item pt-200 pb-150 grow-1">

                <div class="etx-text Text">
                  <p class="font-size-smaller font-color-medium">{{ $texts('label_apprenticeship', 'Lehrberuf') }}</p>
                  <p class="font-size-larger">
                    <span class="font-weight-bold">{{ teaser?.heading }}</span><br>
                    <span class="font-color-medium">{{ teaser?.headingSubline }}</span>
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>

        <div class="Swiper__controls">

          <div class="swiper-pagination Swiper__controls__pagination"></div>

        </div>

      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>
import type { integer } from '@elastic/elasticsearch/lib/api/types';

const props = defineProps<{
  id: string | integer
  parentId: string
}>()

const { $texts } = useNuxtApp()

const { options, isEditing } = defineBlokkli({
  bundle: 'learner_teaser',
  globalOptions: ['spacingTop', 'spacingBottom'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  return classList
})

const entranceClassList = computed(() => {

  const classList = []

  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }

  return classList
})

const currentNode: string = props.parentId ?? '0';
const queryKey = `lernerListing-${currentNode}`;
const queryVars = {
  exclude: [currentNode],
  // limit: 100,
};

const { data: teasers = [] } = await useAsyncData(queryKey, async () => {
  const result = await useGraphqlQuery('lernerListing', queryVars);
  const teasers = result.data?.entityQuery?.items?.map((item: any) => ({
    heading: item.heading,
    headingSubline: item.headingSubline,
    image: item.image,
    url: item.url ? { path: item.url.path } : undefined
  })) ?? [];

  return processTeasers(teasers);
})

function processTeasers(teasers: any[], sliceLength: number = 8): any[] {
  // Shuffle the array
  for (let i = teasers.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [teasers[i], teasers[j]] = [teasers[j], teasers[i]];
  }

  // Return the first `n` elements
  return teasers.slice(0, sliceLength);
}

</script>
